if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', this.onVariantChange.bind(this));
      }

      onVariantChange(event) {
        const target = event.target;
        const selectedOptionValues = this.getSelectedOptionValues();

        if (!selectedOptionValues.length) return;

        publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
          data: {
            event,
            target,
            selectedOptionValues,
          },
        });
      }

      getSelectedOptionValues() {
        return Array.from(
          this.querySelectorAll('input[type="radio"]:checked, select')
        )
          .map((input) => {
            const id = input.dataset.optionValueId;
            if (id && id !== '0' && id !== '') return id;
            return null;
          })
          .filter(Boolean);
      }
    }
  );
}
